import { assoc } from 'ramda';
import { handleActions } from 'redux-actions';

import { updatePropOnId } from 'utils';

import * as types from './actionTypes';

export const initialState = {
	regions: [],
	hoveredRegionId: null,
};

const reducerMap = {
	[types.SET_REGIONS]: (state, { payload }) => {
		return {
			...state,
			regions: payload.regions,
		};
	},
	[types.SET_HOVERED_REGION_ID]: (state, { payload }) => {
		return {
			...state,
			hoveredRegionId: payload.id,
		};
	},
	[types.SET_REGION_ACTIVITY]: (state, { payload }) => {
		return {
			...state,
			regions: updatePropOnId(state.regions, payload.regionId, 'campaigned', payload.active),
		};
	},
	[types.SET_REGIONS_ACTIVITY]: (state, { payload }) => {
		return {
			...state,
			regions: state.regions.map(assoc('campaigned', payload.active)),
		};
	},
	[types.SET_REGION_GUARANTORS]: (state, { payload }) => {
		return {
			...state,
			regions: updatePropOnId(state.regions, payload.regionId, 'guarantors', payload.guarantors),
		};
	},
};

export default handleActions(reducerMap, initialState);
